var LoanTableMappingService = (function () {
    function LoanTableMappingService($http) {
        this.$http = $http;
        this.WsUrl = ResolveUrl("~/LoanData.asmx");
    }
    LoanTableMappingService.prototype.getAll = function () {
        return this.$http.post(this.WsUrl + "/GetAllLoanTableMapping", {});
    };
    LoanTableMappingService.$inject = ["$http"];
    return LoanTableMappingService;
}());
angular
    .module("London.Services")
    .service("LoanTableMappingService", LoanTableMappingService);
